/**
 * Initiates URLSearchParams with the provided params object and stringifies it
 * @param {object} params A params object.
 * @return {string} Stringified search string
 */
function stringifySearchParams<Params extends Record<string, any>>(params: Params) {
  return new URLSearchParams(params).toString();
}

export {stringifySearchParams};
